import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { useGetSailInfoSailMaterial } from "../hooks/useGetSailInfoSailMaterial";

type SailInfoSailMaterialProps = {
    guid: string;
};

const SailInfoSailMaterial: React.FC<SailInfoSailMaterialProps> = ({
    guid,
}) => {
    const { data, isLoading } = useGetSailInfoSailMaterial(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
      <Card sx={{ width: "100%" }}>
            <CardHeader title="Sail Material"></CardHeader>
            <CardContent>
                <Grid container spacing={2}>
                    {data.sail.map((sailItem, index) => (
                        <React.Fragment key={index}>
                            <Grid size={6}>
                                <Typography variant="caption">Sail</Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {sailItem.Dsc}
                                </Typography>
                            </Grid>

                            <Grid size={6}>
                                <Typography variant="caption">
                                    Sold Max AWS
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {sailItem.SoldMaxAws}
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    ))}
                    {data.product.map((productItem, index) => (
                        <React.Fragment key={index}>
                            <Grid size={6}>
                                <Typography variant="caption">
                                    Product
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.Prod}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="caption">
                                    Product Style
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.ProdStyle}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="caption">
                                    Target AM
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.TarAm}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="caption">
                                    AM Min
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.AmMin}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="caption">
                                    AM Rec
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.AmRec}
                                </Typography>
                            </Grid>{" "}
                            <Grid size={6}>
                                <Typography variant="caption">
                                    AM Max
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {productItem.AmMax}
                                </Typography>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoSailMaterial;
